module.exports = __webpack_public_path__ + "9cbb92877163ab2a445db1f26f37d80c.svg";